export default __webpack_public_path__ + "static/media/160x90.5c030351.jpg";